import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import OfferPagePromoLinks from './OfferPagePromoLinks';
import actions from './OfferPagePromoLinks.actions';
import {
    getHeaderNames,
    getLocales,
    getLinks
} from './OfferPagePromoLinks.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderNames,
    locales: getLocales,
    links: getLinks
});

const OfferPagePromoLinksComponent = connect(
    function mapStateToProps(state, {onSave}) {
        return {
            ...mapStateToPropsSelectors(state),
            location: state.routing.locationBeforeTransitions,
            loading: state.links.loading,
            totalPages: state.links.total,
            onSave: onSave,
            publisherIsReferral: state.user.publisher.referral_publisher
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getLinks: actions.getLinks,
            saveLinkPresets: actions.saveLinkPresets,
            savePromoCode: actions.savePromoCode,
            deletePromoCode: actions.deletePromoCode
        };
    }
)(OfferPagePromoLinks);

export default OfferPagePromoLinksComponent;
